import React from 'react';
import classNames from 'classnames';
import BackIcon from '../../../assets/logo/BackIcon';
import InfoIcon from '../../../assets/logo/InfoIcon';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  toggleAllergens: () => void;
  className?: string;
};

const AllergensToggleButton = ({ isOpen, toggleAllergens, className }: Props) => {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:Allergens:AllergensToggleButton' });

  return (
    <button className={classNames('flex space-x-2 items-center', className)} onClick={toggleAllergens}>
      <span
        className={classNames({
          'rounded-full flex items-center justify-center': isOpen,
        })}
      >
        {isOpen ? (
          <div className="w-[18px] h-[18px] flex items-center justify-center border-[1px] border-mobile-secondary rounded-full">
            <BackIcon className="w-[7px] h-[10px] mr-[2px]" color="currentColor" />
          </div>
        ) : (
          <InfoIcon className="w-[18px] h-[18px]" color="currentColor" fill={false} />
        )}
      </span>
      <p>{isOpen ? t('return') : t('product_info')}</p>
    </button>
  );
};

export default AllergensToggleButton;
